module.exports = __webpack_public_path__ + "img/39.6fe073a8.jpg";